module.exports = __webpack_public_path__ + "static/media/merchantIconDefault-2x.691754ed.png";